import { render, staticRenderFns } from "./LeccionC6.vue?vue&type=template&id=2a39ba36&"
import script from "./LeccionC6.vue?vue&type=script&lang=js&"
export * from "./LeccionC6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports